import React from 'react';
import { getPathData } from '../../utils/chart.js';

function PointList(props) {
  const {
    chartData: {
      chartPoints
    },
    yValueKeys,
    colorMap
  } = props;
  const pointListList = yValueKeys.map(yValueKey => {
    const pointList = chartPoints.map(point => ({
      key: point.key,
      x: point.x,
      y: point.y[yValueKey]
    }));
    return {
      key: yValueKey,
      pointList
    };
  });
  return pointListList.map(({
    key,
    pointList
  }) => /*#__PURE__*/React.createElement("path", {
    d: getPathData(pointList),
    stroke: colorMap[key],
    fill: "none",
    strokeWidth: "2pt"
  }));
}

export { PointList as default };
//# sourceMappingURL=index.js.map
